exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".button-d7a4d:not(:first-child){margin-left:5px}.actionHeader-5e141{display:flex;justify-content:space-between;align-items:center}.allocationContainer-35747{width:67%}input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}", ""]);

// Exports
exports.locals = {
	"button": "button-d7a4d",
	"actionHeader": "actionHeader-5e141",
	"allocationContainer": "allocationContainer-35747"
};